export const messages = {
  en: {
    menuGroupCatalog: {
      search: {
        title: 'Search Condition',
        caId: 'caId',
        gId: 'gId',
        storeType: 'storeType',
        createTime: 'createTime',
        placeholder: 'Please enter menuGroupCatalog name'
      },
      list: {
        title: 'menuGroupCatalog List'
      },
      dialog: {
        addTitle: 'Add MenuGroupCatalog',
        editTitle: 'Edit MenuGroupCatalog',
        delTitle: 'Delete MenuGroupCatalog',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        gcId: 'gcId',
        caId: 'caId',
        gId: 'gId',
        storeType: 'storeType',
        createTime: 'createTime',
      },
      table: {
        gcId: 'gcId',
        mgName: 'menu group',
        gId: 'gId',
        storeType: 'storeType',
        createTime: 'createTime',
      },
      validate: {
        gcId: 'Please enter gcId',
        caId: 'Please enter caId',
        gId: 'Please enter gId',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add MenuGroupCatalog success'
      },
      edit: {
        success: 'Edit MenuGroupCatalog success'
      },
      delete: {
        success: 'Delete MenuGroupCatalog success',
        confirm: 'Are you sure to delete this menuGroupCatalog?'
      },
      fetchError: 'Failed to fetch menuGroupCatalog list'
    }
  },
  zh: {
    menuGroupCatalog: {
      search: {
        title: '查询条件',
        mgName: '菜单组',
        gId: '菜单组',
        storeType: '商户类型',
        createTime: '创建时间',
        placeholder: '请输入菜单组名称'
      },
      list: {
        title: '菜单组'
      },
      dialog: {
        addTitle: '添加菜单组',
        editTitle: '编辑菜单组',
        delTitle: '删除菜单组',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        gcId: '目录名称',
        caId: '目录ID',
        gId: '菜单组ID',
        storeType: '商户类型',
        createTime: '创建时间',
      },
      table: {
        gcId: '目录名称',
        mgName: '菜单组',
        gId: '菜单组ID',
        storeType: '商户类型',
        createTime: '创建时间',
      },
      validate: {
        gcId: '请输入目录名称',
        caId: '请输入目录ID',
        gId: '请输入菜单组ID',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加菜单组成功'
      },
      edit: {
        success: '编辑菜单组成功'
      },
      delete: {
        success: '删除菜单组成功',
        confirm: '确认删除该菜单组吗？'
      },
      fetchError: '获取菜单组列表失败'
    }
  },
  'zh-TW': {
    menuGroupCatalog: {
      search: {
        title: '查詢條件',
        mgName: '菜單組',
        gId: '菜單組',
        storeType: '商戶類型',
        createTime: '創建時間',
        placeholder: '請輸入菜單組名稱'
      },
      list: {
        title: '菜單組'
      },
      dialog: {
        addTitle: '添加菜單組',
        editTitle: '編輯菜單組',
        delTitle: '刪除菜單組',
        cancel: '取消',
        confirm: '確定'
      },
      form: {
        gcId: '目錄名稱',
        caId: '目錄ID',
        gId: '菜單組ID',
        storeType: '商戶類型',
        createTime: '創建時間',
      },
      table: {
        gcId: '目錄名稱',
        mgName: '菜單組',
        gId: '菜單組ID',
        storeType: '商戶類型',
        createTime: '創建時間',
      },
      validate: {
        gcId: '請輸入目錄名稱',
        caId: '請輸入目錄ID',
        gId: '請輸入菜單組ID',
        createTime: '請輸入創建時間',
      },
      add: {
        success: '添加菜單組成功'
      },
      edit: {
        success: '編輯菜單組成功'
      },
      delete: {
        success: '刪除菜單組成功',
        confirm: '確認刪除該菜單組嗎？'
      },
      fetchError: '獲取菜單組列表失敗'
    }
  }
}